import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import type { Meeting } from '../../types';
import { Spinner } from '../../components/ui';
import MeetingsList from '../../components/MeetingsList';

export default function Meetings() {
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<Meeting[]>('/meetings')
      .then(setMeetings)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const upcoming = meetings.filter((m) => m.status === 'scheduled');
  const past = meetings.filter((m) => m.status !== 'scheduled');

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Meetings</h1>
      {loading ? (
        <Spinner label="Loading meetings..." />
      ) : (
        <div className="space-y-10">
          <div>
            <h2 className="text-lg font-semibold mb-4">Upcoming</h2>
            <MeetingsList meetings={upcoming} />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Past / Other</h2>
            <MeetingsList meetings={past} />
          </div>
        </div>
      )}
    </div>
  );
}
